const baseUrl = document.getElementById('base-url').getAttribute('data-value') || process.env.REACT_APP_CORE_URL;
const api = {
  appInfo: `${baseUrl}/manage/info`,
  dataController: `${baseUrl}/api/v1/data`,
  contactController: `${baseUrl}/api/v1/contact`,
  projectsController: `${baseUrl}/api/v1/project`,
  readingsData: '/readings',
  readingData: '/reading',
  authorData: '/author',
  authorBooksData: '/readings/author',
  search: '/search',
  projectsData: '/projects',
  projectData: '/project',
  registerProject: '/register'
};

export default api;
